import type { SelectionContext } from '@atlaskit/editor-common/types';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export type SelectionPluginState = {
	// Whether we are pending clearing the `lastSelectionContext` due to a "handoff"
	isPendingSelectionContextClear: boolean;
	lastSelectionContext: SelectionContext | undefined;
	nonCursorSelectionChangeCount: number;
};

export const selectionPluginKey: PluginKey<SelectionPluginState> =
	new PluginKey<SelectionPluginState>('aiExperienceSelection');
